import { queryOptions } from '@tanstack/react-query';
import { fetchMeetingPage } from './meetingPage.ts';

/** One meeting's page, as both its route loader and the view ask for it. */
export function meetingPageQuery(userId: string, meetingId: string) {
  return queryOptions({
    queryKey: ['meetingPage', userId, meetingId],
    queryFn: () => fetchMeetingPage(userId, meetingId),
  });
}
